export function hasNewPolicy(policyDocument, policy, type, id) {
  let found = false;
  if (
    policyDocument &&
    policyDocument.policy_definitions &&
    policyDocument.policy_definitions[policy]
  ) {
    const policyId = policyDocument.policy_definitions[policy];

    policyDocument.groups.forEach((group) => {
      if (!found) {
        if (id && group[type].includes(id)) {
          found = group.policies.includes(policyId);
        } else if (!id) {
          found = group.policies.includes(policyId);
        }
      }
    });
  }

  return found;
}

export function hasOneNewPolicy(policyDocument, policies, type, id) {
  let found = false;
  policies.forEach((policy) => {
    if (!found) {
      found = hasNewPolicy(policyDocument, policy, type, id);
    }
  });

  return found;
}
